// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 456 ? "lottie-web" : chunkId) + "." + {"374":"52e7129314e27f53","456":"cb598a2740a7c690","570":"2bf099da663ba20b","876":"711f4f355aee58f7"}[chunkId] + ".js";
};